// extracted by mini-css-extract-plugin
export default {"root":"qrduj","head":"Ss90Q","icon":"kf_Rv","error":"EAv33","description":"ujxkL","wrapperOtherMethods":"UUEho","tablet":"gkMKF","mobile":"oRHVD","smallMobile":"FwU8V"};